import { Hero } from "./components/Hero/Hero";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer/Footer";


function App() {
  return (

    <div className="App">


      {/* <Navbar /> */}
      {/* <Resume /> */}
      <Hero />
      <Projects />
      <Contact />
      <Footer />

    </div>

  );
}

export default App;
